import { createSyncStoragePersister } from '@tanstack/query-sync-storage-persister';
import { PersistQueryClientProvider } from '@tanstack/react-query-persist-client';
import { useEffect, useState, type ReactNode } from 'react';

import { SESSION_EXPIRED_EVENT } from '../lib/api-client';
import { OFFLINE_CACHE_BUSTER, shouldPersistOfflineQuery } from './offline-cache';
import { CACHE_MAX_AGE, createFinanceQueryClient } from './query-client';

const persister = createSyncStoragePersister({
  key: 'financego-query-cache-v1',
  storage: typeof window === 'undefined' ? undefined : window.localStorage,
  throttleTime: 0,
});

export function QueryProvider({ children }: { readonly children: ReactNode }) {
  const [queryClient] = useState(createFinanceQueryClient);

  useEffect(() => {
    const clearSensitiveCache = () => {
      queryClient.clear();
      void persister.removeClient();
    };
    window.addEventListener(SESSION_EXPIRED_EVENT, clearSensitiveCache);
    return () => window.removeEventListener(SESSION_EXPIRED_EVENT, clearSensitiveCache);
  }, [queryClient]);

  return (
    <PersistQueryClientProvider
      client={queryClient}
      persistOptions={{
        buster: OFFLINE_CACHE_BUSTER,
        dehydrateOptions: {
          shouldDehydrateQuery: shouldPersistOfflineQuery,
        },
        maxAge: CACHE_MAX_AGE,
        persister,
      }}
    >
      {children}
    </PersistQueryClientProvider>
  );
}
